<template>
  <div class="col-lg-12 p-0">
    <label :for="inputConfig.id">{{ inputConfig.name }}</label>
    <!--
        <textarea :id="inputConfig.id" class="form-control" v-model="form[inputConfig.id]"
               ref="general_input_1"
               :placeholder="inputConfig.placeholder" :required="inputConfig.required"
        />-->


    <vue2-tinymce-editor :id="inputConfig.id" ref="general_input_1" v-model="form[inputConfig.id]"
                         @input="refreshComponent"
                         :options="defaultToolbar"></vue2-tinymce-editor>


  </div>
</template>

<script>
import {Vue2TinymceEditor} from "vue2-tinymce-editor";
import {defaultToolbar} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting";

export default {
  name: "Editor1.vue",
  components: {Vue2TinymceEditor},
  props: {
    inputConfig: {},
    form: {}
  },
  computed: {
    defaultToolbar() {
      defaultToolbar['toolbar_sticky'] = false
      return defaultToolbar
    }
  },
  methods: {
    refreshComponent() {
      this.$forceUpdate()
      this.$emit('refresh', true)
    }
  },
  mounted() {
    let input = this.$refs.general_input_1
    let pattern = this.inputConfig.regex
    if (pattern != '') {
      input.pattern = pattern
    }
  }
}
</script>

<style scoped>

</style>